import { startScroll } from './main';
import { stopScroll } from './main';

$(function(){
    let modalContainer = $('.modals'),
        modal = modalContainer.find('.modal'),
        modalBlocker = modalContainer.find('.modal-blocker'),
        modalClose = modalContainer.find('.modal-close'),
        modalElem,
        body = $('body');

    function closeModals() {
        startScroll();
        modalContainer.off('keydown.modalFocus')
        modalContainer.removeClass('open').fadeOut(200, function(){
            modal.attr('tabindex', '-1').hide();
        });

        modalElem.focus();
    }

    function openModal(dataModal) {
        stopScroll(true);
        modal.attr('tabindex', '-1').hide();
        modalContainer.addClass('open').fadeIn(200);
        modalContainer.find('#'+dataModal).attr('tabindex', '0').show().focus();

        // focus trapping
        modalContainer.on('keydown.modalFocus', function(e) {
            let focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                focusableContent = modalContainer.find(focusableElements),
                firstFocusableElement = focusableContent[0],
                lastFocusableElement = focusableContent[focusableContent.length - 1];

            if (e.shiftKey && e.keyCode === 9) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else if (e.keyCode === 9) {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        })
    }

    body.on('click', '.modal-open' ,function(e){
        e.preventDefault();
        modalElem = $(this);
        openModal($(this).attr('aria-controls'));
    })

    modalBlocker.on('click', closeModals);
    modalClose.on('click', closeModals);

    modalContainer.on('keydown', function(e){
        if (e.keyCode === 27) {
            closeModals();
        }
    })

    document.addEventListener('focusin', function(e){
        if (!modalContainer.find(e.target).length && modalContainer.hasClass('open')) {
            closeModals();
        }
    })
})